import { Box } from "@outschool/backpack";
import { useSession } from "@outschool/ui-auth";
import {
  Container,
  TrackingPageSection
} from "@outschool/ui-legacy-component-library";
import React from "react";

import { LowEsaCreditBanner } from "../esaMemberships/LowEsaCreditBanner";
import AvailableSeatsFromWaitlistBanner from "../loggedInHome/AvailableSeatsFromWaitlistBanner";
import EnrolledLearnerSuccessBanner from "../loggedInHome/EnrolledLearnerSuccessBanner";
import FeaturedClasses from "../loggedInHome/FeaturedClasses";
import { AddLearnerBanner } from "../loggedInHome/learnerCards/AddLearnerBanner";
import { LoggedInHomeMyClassesList } from "../loggedInHome/LoggedInHomeMyClassesList";
import StickyHeader from "./tabs/StickyHeader";

export default function ParentDashboardMobile({ children }: $TSFixMe) {
  const topNode = React.useRef<HTMLElement>(null);

  const { currentUser } = useSession();

  return (
    <>
      <StickyHeader watchNode={topNode} />
      <Box ref={topNode} />
      <AddLearnerBanner />
      <EnrolledLearnerSuccessBanner />
      <AvailableSeatsFromWaitlistBanner />
      {currentUser?.hasEsaMembership && <LowEsaCreditBanner />}

      <Container sx={{ marginY: "24px" }}>
        <LoggedInHomeMyClassesList />
        <FeaturedClasses />
        <TrackingPageSection name="parent dashboard cards" uniqueId="banner">
          {setImpressionNode => (
            <Box
              ref={setImpressionNode}
              key="banner"
              sx={{
                marginBottom: "24px",
                marginY: "1em"
              }}
            >
              {children}
            </Box>
          )}
        </TrackingPageSection>
      </Container>
    </>
  );
}
